/**
 * CSS produk Spotlight yang di-inline ke IIFE (`mjl-spotlight.min.js`).
 *
 * Hanya class yang terpakai di source Spotlight yang masuk bundle.
 * Token tetap dari `@mjl/ui-kit` supaya tampilan seragam dengan My Apps.
 */
import { joinCss } from '@mjl/shared';
import tokens from '@mjl/ui-kit/styles?inline';
import tailwind from './widget-tailwind.css?inline';
import post from '@mjl/ui-kit/styles/post-tailwind?inline';
import custom from './custom.scss?inline';

/** String CSS siap pakai untuk `attachUiKitShadow` (Shadow Root). */
export const widgetCss = joinCss(tokens, tailwind, post, custom);
